import get from 'lodash/get';

export const selectStatus = (state) => get(state, 'settings.twoFactor.status', 'disabled'); // api returns: disabled, requested, confirmed.

export const selectMessage = (state) => get(state, 'settings.twoFactor.message', '');

export const selectError = (state) => get(state, 'settings.twoFactor.error', false);

export const selectChecked = (state) => get(state, 'settings.twoFactor.checked', false);
